// Styles
import styled from 'styled-components'

// Core
import React, {PropsWithChildren} from 'react'

type DivItem = PropsWithChildren<{className?: string}>
export const CheckoutSummaryItem = (props: DivItem) => <CheckoutSummaryItem.Styled {...props} />

export const CheckoutSummaryDivider = () => <CheckoutSummaryDivider.Styled />

CheckoutSummaryItem.Styled = styled.div`
  width: 351px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  column-gap: 8px;
`

CheckoutSummaryDivider.Styled = styled(CheckoutSummaryItem)`
  border-bottom: 1px solid ${({theme}) => theme.colors.stone.light};
`
